var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('legend', [_vm._v("Print Label")]), _vm._v(" "), _c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [(!_vm.isManualEntryRestrict) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "FlyerBarcode",
      "value": "0",
      "disabled": _vm.IsDtoRestrict && !_vm.memcacheFlag
    },
    domProps: {
      "checked": _vm._q(_vm.selected, "0")
    },
    on: {
      "change": function($event) {
        _vm.selected = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "FlyerBarcode"
    }
  }, [_vm._v(" DTO Paper Sheet ")])]), _vm._v("  \n                    "), _c('span', {
    staticClass: "input-group-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "awb",
      "value": "1",
      "disabled": !_vm.IsDtoRestrict && !_vm.memcacheFlag
    },
    domProps: {
      "checked": _vm._q(_vm.selected, "1")
    },
    on: {
      "change": function($event) {
        _vm.selected = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "awb"
    }
  }, [_vm._v(" RTO/DTO Sticker ")])])]), _vm._v(" "), _c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == ''),
      expression: "selected == ''"
    }],
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "shippingID"
    }
  })])], 1), _vm._v(" "), _c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '0'),
      expression: "selected == '0'"
    }],
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        santiseShippingID: true
      }),
      expression: "{required: true, santiseShippingID:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "shippingID",
      "type": "text",
      "name": "shippingID",
      "placeholder": "Enter/Scan Flyer Code"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "keypress": _vm.barcodeevent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1'),
      expression: "selected == '1'"
    }],
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shipment),
      expression: "shipment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "shipment",
      "type": "text",
      "name": "shipment",
      "placeholder": "Enter/Scan AWB OR Flyer Code"
    },
    domProps: {
      "value": (_vm.shipment)
    },
    on: {
      "keypress": _vm.barcodeevent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipment = $event.target.value
      }
    }
  })])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isManualEntryRestrict) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "FlyerBarcode",
      "value": "0",
      "disabled": _vm.IsDtoRestrict && !_vm.memcacheFlag
    },
    domProps: {
      "checked": _vm._q(_vm.selected, "0")
    },
    on: {
      "change": function($event) {
        _vm.selected = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "FlyerBarcode"
    }
  }, [_vm._v(" DTO Paper sheet ")])]), _vm._v("  \n                      "), _c('span', {
    staticClass: "input-group-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "awb",
      "value": "1",
      "disabled": !_vm.IsDtoRestrict && !_vm.memcacheFlag
    },
    domProps: {
      "checked": _vm._q(_vm.selected, "1")
    },
    on: {
      "change": function($event) {
        _vm.selected = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "awb"
    }
  }, [_vm._v(" RTO/DTO Sticker ")])])]), _vm._v(" "), _c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == ''),
      expression: "selected == ''"
    }],
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "shippingID"
    }
  })])], 1), _vm._v(" "), _c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '0'),
      expression: "selected == '0'"
    }],
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "shippingID",
    class: {
      'form-control': true,
      'error': _vm.errors.has('shippingID')
    },
    attrs: {
      "type": "text",
      "placeholder": "Please Enter/Scan AWB for RTO or Scan Flyer Barcode for DTO",
      "autocomplete": "off",
      "oncopy": "return false",
      "onpaste": "return false",
      "name": "shippingID",
      "id": "shippingID"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "drop": _vm.handleDragOver,
      "keydown": _vm.detectInputForStickerPrint,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }, _vm.handleInputForStickerPrint]
    }
  })])], 1), _vm._v(" "), _c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1'),
      expression: "selected == '1'"
    }],
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipment),
      expression: "shipment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "shipment",
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipment')
    },
    attrs: {
      "type": "text",
      "placeholder": "Please Enter/Scan AWB for RTO or Scan Flyer Barcode for DTO",
      "autocomplete": "off",
      "oncopy": "return false",
      "onpaste": "return false",
      "name": "shipment",
      "id": "shipment"
    },
    domProps: {
      "value": (_vm.shipment)
    },
    on: {
      "drop": _vm.handleDragOver,
      "keydown": _vm.detectInputForDTOPaperSheet,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.shipment = $event.target.value
      }, _vm.handleInputForDTOPaperSheet]
    }
  })])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "submitRadioBtnCSS col-md-12 mt-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1'),
      expression: "selected == '1'"
    }],
    staticClass: "input-group-text ml-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelectPrinter),
      expression: "isSelectPrinter"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "oldPrint",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isSelectPrinter, "0")
    },
    on: {
      "change": function($event) {
        _vm.isSelectPrinter = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "FlyerBarcode"
    }
  }, [_vm._v(" Print ")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1'),
      expression: "selected == '1'"
    }],
    staticClass: "input-group-text ml-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelectPrinter),
      expression: "isSelectPrinter"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "newPrint",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isSelectPrinter, "1")
    },
    on: {
      "change": function($event) {
        _vm.isSelectPrinter = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "awb"
    }
  }, [_vm._v(" New Print ")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '0'),
      expression: "selected == '0'"
    }],
    staticClass: "btn btn-sm btn-primary ml-4",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading == true
    },
    on: {
      "click": _vm.submitform
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Show Shipment Label")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1'),
      expression: "selected == '1'"
    }],
    staticClass: "btn btn-sm btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading == true
    },
    on: {
      "click": _vm.submitform
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected != ''),
      expression: "selected != ''"
    }],
    staticClass: "btn btn-sm btn-danger ml-4",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading == true
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("Reset")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.validationerror))])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isRedirectLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isRedirectLoading = $event
      }
    }
  }, [_vm._v(_vm._s(_vm.redirectionMsg))])], 1), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shipmentDetails.length > 1),
      expression: "shipmentDetails.length > 1"
    }],
    staticClass: "b-table table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', {
    staticClass: "text-center tableheader"
  }, [_c('th', [_vm._v("Sr.No")]), _vm._v(" "), _c('th', [_vm._v("Shipment ID")]), _vm._v(" "), _c('th', [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Last Modified Date")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "text-left"
  }, _vm._l((_vm.shipmentDetails), function(row, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.AWBNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateFormat")(row.LastModifiedDate)))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.printDTOslip(row.AWBNumber)
        }
      }
    }, [_c('u', [_c('font', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("Print")])], 1)])])])
  }), 0)]), _vm._v(" "), _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])], 1)])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f23aae5","hasScoped":true}!./src/views/components/RVPPrintLabel/RVPPrintLabel.component.html
// module id = 1301
// module chunks = 1